<template>
  <form @submit.prevent.stop="saveTeam"
        class="team-form text-left"
        action=""
        :data-id="team.id">
    <!--    <pre class="text-white">-->
    <!--      {{team.users}}-->
    <!--    </pre>-->
    <!--    {{childIds}}-->
    <div class="fpart fhead">
      <div class="row">
        <div class="col-md-12">
          <div class="header d-flex align-items-baseline">
            <h2 v-if="team.id">
              {{ $t('message.edit_team') }}
            </h2>
            <h2 v-else>
              {{ $t('message.create_a_team') }}
            </h2>
          </div>
        </div>
        <div class="col-md-12">
          <nav class="tabnav tab-nav mb-0">
            <button
              :class="(tab === 0 ? 'active' : '')"
              @click.stop.prevent="setTab(0)"
              class=" btn-link btn tab-link">
              {{ $t('message.information') }}
            </button>
            <button
              :class="(tab === 1 ? 'active' : '')"
              @click.stop.prevent="setTab(1)"
              class=" btn-link btn tab-link">
              {{ $t('message.members') }}
            </button>
            <!--            <button-->
            <!--              :class="(tab === 2 ? 'active' : '')"-->
            <!--              @click.stop.prevent="setTab(2)"-->
            <!--              class=" btn-link btn tab-link">-->
            <!--              {{ $t('message.settings') }}-->
            <!--            </button>-->
          </nav>
        </div>
      </div>
    </div>
    <div class="fpart fbody">
      <div v-show="tab === 0" class="tab-content form-set">
        <div class="">
          <div class="row">
            <div class="col-md-12">
              <div class=" mb-2" v-if="!team.company">
                <label for="parentteam">
                  {{ $t('message.parent_team') }}
                </label>
                <select class="form-control styled-input" v-model="team.parent" name="parentteam" id="parentteam">
                  <option value="null" selected="selected">
                    - {{ $t('message.none') }} -
                  </option>
                  <option v-for="team in teams" :value="team.id">
                    {{ team.Title }}
                  </option>
                </select>
              </div>
              <div class=" mb-2">
                <label for="Title">
                  {{ $t('message.team_name') }}
                </label>
                <input name="Title" id="Title"
                       type="text"
                       required
                       class="form-control styled-input"
                       v-model="team.title">
              </div>
            </div>
            <div class="col-md-6">
              <div class=" mb-2">
                <label for="files">
                  {{ $t('message.image') }}
                </label>
                <file-upload :image-url="team.logo ? (url + team.logo.url) : ''"
                             class="styled-input team-logo-input"
                             ref="upload"
                             :name="'files'">
                </file-upload>
                <button @click.prevent="team.logo = null" type="button"
                        class="d-block m-auto btn-sm small_btn small btn btn_small btn-danger"
                        v-if="team.logo">
                  {{ $t('message.delete') }}
                </button>
              </div>
            </div>
            <div class="col-md-6 d-flex flex-column">
              <label for="Information">
                {{ $t('message.information') }}
              </label>
              <textarea class="flex-grow-1 form-control styled-input"
                        name="Information"
                        id="Information"
                        cols="30" rows="5"
                        v-model="team.information">
            </textarea>
            </div>
          </div>
        </div>
      </div>
      <div v-show="tab === 1" class="tab-content form-set">
        <div class="">
          <div class=" mb-4">
            <label for="">
              {{ $t('message.managed_by') }}
            </label>
            <v-select :placeholder="$t('message.add_team_manager')"
                      @input="addAdmin"
                      @search="searchUsers"
                      :filterable="false"
                      class="styled-input add_admin"
                      v-model="selected"
                      :options="sortedUsers">
            </v-select>
            <template v-for="manager in team.managedBy">
              <div>
                {{ manager.firstname }}
                {{ manager.lastname }}
                <button @click.prevent.stop="removeAdmin(manager.id)" class="btn-link btn p-0">
                  <i class="far fa-trash-alt"></i>
                </button>
              </div>
            </template>
          </div>
          <div class=" mb-4">
            <label for="">
              {{ $t('message.members') }}
            </label>
            <v-select :placeholder="$t('message.add_team_member') "
                      @input="addMember"
                      @search="searchUsers"
                      :filterable="false"
                      class="styled-input add_member"
                      v-model="selected"
                      :options="sortedUsers">
            </v-select>
            <template v-for="t in team.users">
              <div>
                {{ t.firstname }}
                {{ t.lastname }}
                <button @click.prevent.stop="removeMember(t.id)" class="btn-link btn p-0">
                  <i class="far fa-trash-alt"></i>
                </button>
              </div>
            </template>
          </div>
        </div>
      </div>
      <!--      <div v-show="tab === 2" class="tab-content form-set">-->
      <!--        <div class="toggler d-flex ml-auto">-->
      <!--          {{ $t('message.is_finalized') }}-->
      <!--          <label class=" ml-2 switch">-->
      <!--            <input v-model="team.isFinalized" type="checkbox">-->
      <!--            <span class="slider round">-->
      <!--              <span class="w-50 h-100 float-left d-flex align-items-center justify-content-center small"></span>-->
      <!--              <span class="w-50 h-100 float-right d-flex align-items-center justify-content-center small"></span>-->
      <!--            </span>-->
      <!--          </label>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <div class="fpart ffoot">
      <div class="row mt-3">
        <div v-if="team.id && !teamHasChildren" class="col text-left row m-0">
          <button v-if="!showConfirmation" @click.prevent.stop="showConfirmation = true"
                  class="pl-0 text-danger btn btn-form">
            {{ $t('message.delete_team') }}
          </button>
          <form class="flex-wrap d-flex" v-if="showConfirmation">
            <input v-model="deleteConfirmation"
                   class="flex-grow-1 w-auto  m-0 form-control styled-input"
                   :placeholder="$t('message.type_delete_to_confirm')" type="text">
            <button :disabled="!deleteConfirmed" :class="deleteConfirmed ? '' : 'disabled'"
                    @click.prevent.stop="deleteTeam"
                    class="flex-shrink-0 btn btn-form ml-2 btn-danger">
              {{ $t('message.delete_team') }}
            </button>
            <button @click.prevent.stop="showConfirmation = false"
                    class="flex-shrink-0 btn btn-link">
              {{ $t('message.cancel') }}
            </button>
            <p class="m-0  text-danger small mt-2 w-100 flex-shrink-0">
              {{ $t('message.warning_this_cannot_be_undone') }}</p>
          </form>
        </div>
        <div class="ml-auto col-auto text-right">
          <button @click.prevent="cancelSave" class="btn btn-link btn-form">
            {{ $t('message.close') }}
          </button>
          <button v-if="showSave" type="submit" class="btn btn-primary btn-form submitformbtn ">
            {{ $t('message.save') }}
          </button>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import FileUpload from "../FileUpload";
import store from "../../store/store";

export default {
  components: {
    FileUpload: FileUpload
  },
  created() {
    this.initialTeam = JSON.parse(JSON.stringify(this.team))
    this.getChildTeamIds(this.team);
    this.company = store.getters.getCompany;
    this.getAllTeams();
    this.getUserOptions()
  },
  mounted() {
    if (this.team.id) {
      if (this.team.Title) {
        this.transformObject()
      }
    }
  },
  methods: {
    cancelSave() {
      for (let key in this.team) {
        this.team[key] = this.initialTeam[key]
      }
      this.closePopup()
    },
    clearLogo() {
      let uploadfile = this.$refs.upload.fileUrl;
      this.team.logo = null;
      uploadfile = ''
    },
    closePopup(reload = false) {
      this.$emit('closePopup', reload)
    },
    transformObject() {
      this.team.title = this.team.Title;
      this.team.information = this.team.Information;
      if (this.team.parent) {
        this.team.parent = this.team.parent.id
      }
    },
    async uploadImage(id) {

      const formElement = document.querySelector('.team-form');
      const fileData = new FormData(formElement);
      fileData.delete('Information');
      fileData.delete('Title');
      fileData.append(
        'ref', 'teams'
      );
      fileData.append(
        'refId', id
      );
      fileData.append(
        'field', 'logo'
      );

      return await this.axios.post('/upload', (fileData))

    },
    setTab(i) {
      this.tab = i;
    },
    searchUsers(search, loading) {
      if (search.length > 2) {
        this.axios.get('/users?_limit=10&fullname_contains=' + search + '&_sort=lastname:DESC').then(res => {
          this.users = res.data
        })
      } else {
        this.users = this.allusers
      }
    },
    getUserOptions() {
      this.axios.get('/users?_sort=id:DESC&_limit=10').then(res => {
        this.users = res.data
        this.allusers = res.data
      })
    },
    getAllTeams() {
      let id = '';
      if (this.team.id) {
        id = '&id_nin=' + this.team.id
      }
      this.childIds.forEach(chid => {
        id += '&id_nin=' + chid
      });
      this.axios.get('/teams/teamlist?status=1&_limit=-1' + id).then(res => {
        this.teams = res.data
        this.showSave = true;
      });
    },
    getChildTeamIds(team) {
      this.childIds.push(team.id);
      // console.log(team)
      if (team.teams) {
        team.teams.forEach(childTeam => {
          this.getChildTeamIds(childTeam)
        })
      }
    },
    deleteTeam(e) {
      if (this.deleteConfirmed) {
        const el = e.target;
        el.classList.add('loading');

        this.team.teams.forEach((team, index) => {
          this.addTeamToCompany(team.id)
        });

        this.team.managedBy = [];
        this.team.parent = null;
        this.team.teams = [];
        this.team.users = [];
        this.team.status = false;

        this.axios.put('/teams/' + this.team.id, this.team).then(res => {
          this.loadingSuccess(el);
          this.$emit('reload');
          this.closePopup();
        })
      }
    },
    async createTeam(e) {
      return await this.axios.post('/teams', this.team
      );
    },
    async editTeam(e) {
      return await this.axios.put('/teams/' + this.team.id, this.team
      )
    },
    isTeamValid() {
      let valid = true;
      if (this.team.title.length <= 0) {
        valid = false;
      }
      return valid;
    },
    async saveTeam(e) {
      let btn = this.$el.querySelector('.submitformbtn');
      btn.classList.add('loading');
      btn.disabled = true;
      if (this.isTeamValid()) {
        this.team.Title = this.team.title;//formatting
        this.team.Information = this.team.information;//formatting
        const saveResponse = this.team.id == null ? await this.createTeam(e) : await this.editTeam(e);
        const logoinput = document.querySelector('#files');
        if (logoinput.value) {
          await this.uploadImage(saveResponse.data.id);
        }
        await this.postSaveHandler(e, saveResponse.data);
      } else {
        //todo show errors for invalid fields as fallback for html validation
      }
    },
    async postSaveHandler(e, team) {
      await this.checkCompanyLink(team);
      const log = await this.logActivity('Edited team', 'info (HR)');
      let btn = this.$el.querySelector('.submitformbtn');
      btn.disabled = false;
      this.loadingSuccess(btn);
      this.closePopup();
      this.$emit('reload', log);
    },
    async checkCompanyLink(team) {
     // console.log('team parent',team.parent)
      if (team.parent === 'null' || team.parent === null || !team.parent || team.parent.length < 1) {
        return await this.addTeamToCompany(team.id)
      } else {
        return await this.removeTeamFromCompany(team.id)
      }
    },
    addMember(user) {
      let alreadymember = false;
      if (!this.team.users) {
        this.team.users = [];
      }
      this.team.users.forEach((member, ind) => {
        if (member.id === user.id) {
          alreadymember = true;
        }
      });
      if (!alreadymember) {
        this.team.users.push(user);
      }
      this.selected = null
    },
    addAdmin(user) {
      let alreadymanager = false;
      if (!this.team.managedBy) {
        this.team.managedBy = [];
      }
      this.team.managedBy.forEach((manager, ind) => {
        if (manager.id === user.id) {
          alreadymanager = true;
        }
      });
      if (!alreadymanager) {
        this.team.managedBy.push(user);
      }
      this.selected = null
    },
    removeMember(id) {
      let member = false;
      let index = null;
      let index2 = null;
      this.team.users.forEach((val, ind) => {
        if (val.id == id) {
          member = true;
          index = ind;
        }
      });

      if (member) {
        this.team.users.splice(index, 1);
      }
    },
    removeAdmin(id) {
      let member = false;
      let index = null;
      let index2 = null;
      this.team.managedBy.forEach((val, ind) => {
        if (val.id == id) {
          member = true;
          index = ind;
        }
      });

      if (member) {
        this.team.managedBy.splice(index, 1);
      }
    },
    async addTeamToCompany(team_id) {
      const company = await this.axios.get('/companies/' + this.company.id)
      // console.log('company', company)
      const company_teams = company.data.teams;
      let already_child = false;
      company_teams.forEach((team, index) => {
        if (team.id === team_id) {
          already_child = true;
        }
      });
      if (!already_child) {
        company_teams.push(team_id);
      }
      return await this.axios.put('/companies/' + this.company.id, {
        teams: company_teams
      })
    },
    async removeTeamFromCompany(team_id) {
      const company = await this.axios.get('/companies/' + this.company.id)
      // console.log('company', company)
      const company_teams = company.data.teams;
      company_teams.forEach((team, index) => {
        if (team.id === team_id) {
          company_teams.splice(index, 1)
        }
      });
      return await this.axios.put('/companies/' + this.company.id, {
        teams: company_teams
      })
    },
  },
  data() {
    return {
      initialTeam: null,
      childIds: [],
      company: null,
      selected: null,
      deleteConfirmation: '',
      deleteConfirmed: false,
      showConfirmation: false,
      tab: 0,
      managers: [],
      originalParent: '',
      parentTeam: null,
      teams: [],
      memberIds: [],
      managerIds: [],
      users: [],
      allUsers: [],
      showSave: false
    }
  },
  watch: {
    deleteConfirmation() {
      this.deleteConfirmed = this.deleteConfirmation === 'DELETE';
    }
  },
  computed: {
    sortedUsers() {
      const sortedUsers = _.sortBy(this.users, [user => user.lastname ? user.lastname.toLowerCase() : user.lastname]);
      // const sortedUsers = _.sortBy(this.users, [user => user.lastname.toLowerCase()]);
      sortedUsers.forEach(u => {
        u.label = u.lastname + ' ' + u.firstname
      })
      return sortedUsers
    },
    fileChosen() {
      let r = '';
      if (this.$refs.upload) {
        r = this.$refs.upload.fileUrl;
      }
      return r
    },
    teamHasChildren() {
      let children = false;

      if (this.team.teams) {
        if (this.team.teams.length) {
          children = true
        }
      } else if (this.team.teams) {
        if (this.team.teams.length) {
          children = true
        }
      }
      return children
    }
  },
  props: {
    team: {
      type: Object,
      default() {
        return {
          parent: null,
          id: null,
          Information: '',
          Title: '',
          managedBy: [],
          users: [],
        }
      }
    }

  }
}
</script>


<style lang="scss">
.vs__dropdown-menu {
  display: block !important
}

</style>



// WEBPACK FOOTER //
// src/components/Teams/TeamForm.vue